<template>
    <div class="newEnLogin flex">
        <div class="newEnLogin-left">
            <img src="../../assets/images/newlogin.png" alt="">
        </div>
         <div class="newEnLogin-right flex  align-cen">
            <div class="newEnLogin-right-form">
                <img src="../../assets/images/newLogintit.png" alt="">
                <div class="form-cen">
                     <div class="newEnLogin-right-form-swich flex align-cen">
                    <div class="con conactive">密码登录</div>
                    <div class="con" @click="goReg">账号注册</div>
                </div>
                <div class="newEnLogin-right-form-line"></div>
                <div class="goReg"  @click="goReg">没有账号？<span style="color:#285B9C;cursor: pointer;">免费注册</span></div>
                      <div class="enform-ipt">
                <el-form  :model="form" ref="form" >
               <el-input placeholder="请输入账号" v-model="form.username" clearable></el-input>
               <el-input placeholder="请输入密码"   v-model="form.password" show-password  clearable></el-input>
                </el-form>
            </div>
            <div class="enform-forget" @click="openreg">
                忘记密码？
                </div> 
             <el-button class="enform-btn" @click="onsub" :loading="loading">
                 登录
            </el-button>
                </div>
            </div>
            <div class="botinfo">
            <p>
                Copyright © 2023 北京和隆优化科技股份有限公司  
            </p>
            <p>
                京ICP备13020522号
            </p>
            <p>技术支持：北京和隆软件有限公司</p>
         </div>
         </div>
    </div>
    <!-- <div class="enLogin">
        <div class="enCenForm">
            <img src="../../assets/images/qy_tit.png" alt="" class="qy_tit">
            <div class="enCenForm-form flex align-cen">
                <div class="left_bg">
                    <img src="../../assets/images/left_bg.png" alt="" class="">
                </div>
                <div class="right-form">
                    <div class="enform-tit">
                账号登录
                     </div>
                      <div class="goReg"  @click="goReg">没有账号？<span style="color:#285B9C;cursor: pointer;">免费注册</span></div>
                       <div class="enform-ewm">
                 <el-tooltip class="item" effect="dark" content="暂未开放" placement="top-start">
                <img src="../../assets/images/enewm.png" alt="">
                  </el-tooltip>
                     </div>
                      <div class="enform-ipt">
                <el-form  :model="form" ref="form" >
               <el-input placeholder="请输入账号" v-model="form.username" clearable></el-input>
               <el-input placeholder="请输入密码"   v-model="form.password" show-password  clearable></el-input>
                </el-form>
            </div>
            <div class="enform-forget" @click="openreg">
                忘记密码？
                </div> 
                <el-button class="enform-btn" @click="onsub" :loading="loading">
                 登录
            </el-button>
                </div>
            </div>
        </div>
        <div class="enform">
            <div class="enform-tit">
                账号登录
            </div>
            <div class="enform-ewm">
                 <el-tooltip class="item" effect="dark" content="暂未开放" placement="top-start">
                <img src="../../assets/images/enewm.png" alt="">
                  </el-tooltip>
            </div>
            <div class="enform-ipt">
                <el-form  :model="form" ref="form" >
               <el-input placeholder="请输入账号" v-model="form.username" clearable></el-input>
               <el-input placeholder="请输入密码"   v-model="form.password" show-password  clearable></el-input>
                </el-form>
            </div>
            <div class="flex align-cen"> 
                <div class="goReg" style="padding-left:40px" @click="goReg">暂无账号？<span style="color:#4A93F6;cursor: pointer;">立即注册</span></div>
                 <div class="enform-forget mft" @click="openreg">
                忘记密码？
                </div>
            </div>
            <div class="enform-btn">
                 <img src="../../assets/images/enbtn.png" alt=""  @click="onsub">
            </div>
        </div>
    </div> -->
</template>
<script>
import { login } from "@/api/auth/login"
import LocaStorage from "../../utils/localstorage.js"
const token1 = LocaStorage.setAge().get('token1')
export default {
    name:'enLogin',
    data(){
        return {
            form:{
                username:'',
                password:''
            },
            loading:false
        }
    },
    created(){
        document.title = "和隆优化-企业登录"
    },
    methods: {
        goReg(){
        if(this.$route.query.id){
      // 打开注册页面、有id时
        let param = {}
        if(this.$route.query.redirectUrl == 'endowloadDetail'){
            param = {
               appId:this.$route.query.id,
               type:1 
            }
        }
         if(this.$route.query.redirectUrl == 'enSolution'){
                param = {
               solutionId:this.$route.query.id,
               type:1 
            }
         }
          if(this.$route.query.redirectUrl == 'enCourseDetail'){
                param = {
               courseId:this.$route.query.id,
            }
         }
        this.$router.push({
            name:'register',
            query: param
         })
        }
        else if(this.$route.query.clueType){
        // 打开注册页面、有固定线索时
               let param = {
               clueType:this.$route.query.clueType,
               type:1, 
               redirectUrl:this.$route.query.redirectUrl 
            }
             this.$router.push({
            name:'register',
            query: param
         })
         }
        else if(this.$route.query.dataJson){
            // 打开注册页面、有邀请数据时
               let param = {
               dataJson:this.$route.query.dataJson,
               type:1, 
            }
             this.$router.push({
            name:'register',
            query: param
         })
        }
        else{
            let param = this.$route.query.type ? {type:1,redirectUrl:this.$route.query.redirectUrl,viewtype:this.$route.query.type} : {type:1,redirectUrl:this.$route.query.redirectUrl}
            this.$router.push({
            name:'register',
            query: param
         }) 
        }
        },
        //打开忘记密码
        openreg(){
              if(this.$route.query.id){
      // 打开注册页面、有id时
        let param = {}
        if(this.$route.query.redirectUrl == 'endowloadDetail'){
            param = {
               appId:this.$route.query.id,
               type:2
            }
        }
         if(this.$route.query.redirectUrl == 'enSolution'){
                param = {
               solutionId:this.$route.query.id,
               type:2
            }
         }
          if(this.$route.query.redirectUrl == 'enCourseDetail'){
                param = {
               courseId:this.$route.query.id,
            }
         }
        this.$router.push({
            name:'register',
            query: param
         })
        }
        else if(this.$route.query.clueType){
        // 打开注册页面、有固定线索时
               let param = {
               clueType:this.$route.query.clueType,
               type:2, 
               redirectUrl:this.$route.query.redirectUrl 
            }
             this.$router.push({
            name:'register',
            query: param
         })
         }
        else if(this.$route.query.dataJson){
            // 打开注册页面、有邀请数据时
               let param = {
               dataJson:this.$route.query.dataJson,
               type:2, 
            }
             this.$router.push({
            name:'register',
            query: param
         })
        }
        else{
                   this.$router.push({
            name:'register',
            query: {
                type:2,
                redirectUrl:this.$route.query.redirectUrl 
            }
         }) 
        }
        },
        // 登录
       
        onsub(){
            if(!this.form.username){
               return this.$message.error('请输入账号');
            }
             if(!this.form.password){
               return this.$message.error('请输入密码');
            }
            let params = {
                 username:this.form.username,
                 password:this.form.password,
                 appId:this.$route.query.redirectUrl == 'endowloadDetail' ? this.$route.query.id : '',
                 solutionId:this.$route.query.redirectUrl == 'enSolution' ? this.$route.query.id : '',
                 clueType:this.$route.query.clueType || ''
            }
			if(token1){
				localStorage.removeItem('token1')
				localStorage.removeItem('userinfo1')
			}
            this.loading = true
             login(params,2,'enterprise').then((res) => {
                 this.loading = false
                let that = this
				      if(res.access_token) {
                        that.$bus.$emit("tokenStatus",true);
                        that.$bus.$emit("footerReload",true);
                        LocaStorage.setAge().set('token1',res.token_type + ' ' + res.access_token)
                         LocaStorage.setAge().set('userinfo1',res.user_info)
					   if(that.$route.query.redirectUrl){
                        if(!that.$route.query.id){
                        setTimeout(() => {
					    that.$router.push({
                        name:that.$route.query.redirectUrl,
                        query:that.$route.query.type ? {type:that.$route.query.type} : that.$route.query.clueType ? {IsService:1} : {}
                        })
                        },100);
                        }else{
                            let params
                            if(that.$route.query.index){
                                params = {
                            id:that.$route.query.id,
                            type:that.$route.query.type,
                                 }
                            }
                            else if(that.$route.query.currentNav1 || that.$route.query.currentNav1 == 0){
                                  params = {
                                    id:that.$route.query.id,
                                    currentNav1:that.$route.query.currentNav1,
                                 }   
                                }
                            else{
                                params = {
                             id:that.$route.query.id,
                            type:that.$route.query.type,
                            IsService:that.$route.query.redirectUrl == "endowloadDetail" ? 1 : that.$route.query.redirectUrl == "enSolution" ? 1 : '',
                            index:that.$route.query.index,
                            data:that.$route.query.data,
                           }
                         }
                              setTimeout(() => {
                                    that.$router.push({
                                    name:that.$route.query.redirectUrl == "enCourseDetail" ? 'enBusiness' : that.$route.query.redirectUrl,
                                    query:params
                                })
                                },100); 
                        }
                       }else{
                         if(this.$route.query.dataJson){
                            if(this.$route.query.iscreat){
                                  that.$router.push({
                                    name:that.$route.query.replaceUrl,
                                    query:{
                                        dataJson:this.$route.query.dataJson
                                    }
                                })
                            }else{
                            that.$router.replace({
                                name:'inviteAccount',
                                query:{
                                    dataJson:this.$route.query.dataJson
                                }
                            })
                            }
                         }else{
                             setTimeout(() => {
                                that.$router.push({
                                name:that.$route.query.redirectUrl || 'homePage',
                            })
                            },100);
                         }
                       }
				      }else{
						that.$message.error('登录失败'); 
					  }
				    }).catch(err => {
                         this.loading = false
			 });
        },
    }
}
</script>
<style lang="scss" scoped>
.newEnLogin{
    width: 100%;
    height: 100vh; 
    overflow: hidden;
    position: relative;
    .newEnLogin-left{
        width: 70vw;
        height: inherit;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .newEnLogin-right{
        width: 30vw;
        height: 100%;
        background: #fff;
        box-shadow: 0 4px 13px rgba(0, 0, 0, 0.2);
          position: relative;
        .newEnLogin-right-form{
            width: 70%;
            margin: 0 auto;
            img{
                width: 100%;
                max-height: 75px;
            }
            .form-cen{
                padding: 50px 0px;
                .newEnLogin-right-form-swich{
                    .con{
                        width: 50%;
                        text-align: center;
                        font-size: 18px;
                        cursor: pointer;
                    }
                    .conactive{
                       color: #3A7ACC;
                       position: relative;
                    }
                    .conactive::after{
                        content: '';
                        position: absolute;
                        width: 36px;
                        height: 3px;
                        background: #3A7ACC;
                        bottom: -12px;
                        left: 50%;
                        margin-left: -18px;
                    }
                }
                .newEnLogin-right-form-line{
                    width: 100%;
                    height: 1px;
                    background: #CCCCCC;
                    margin-top: 10px;
                }
                 .goReg{
                         font-size: 14px;
                        color: #767676;
                        margin-bottom: 10px;
                        padding-top: 20px;
                    }
                          .enform-ipt{
                        margin-top: 30px;
                        padding-bottom: 0px;
                    }
                   .enform-forget{
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #2C71C8;
                    line-height: 18px;
                    text-align: right;
                    cursor: pointer;
                }
                   .enform-btn{
                   background: #2C71C8;
                   border-radius: 2px;
                   width: 100%;
                   text-align: center;
                   padding: 1.5vh 0;
                   color: #fff;
                   font-size: 16px;
                   margin-top: 5vh;
                   cursor: pointer;
                   outline: none;
                   border: none;
                }
            }
        }
        .botinfo{
            position: absolute;
            font-size: 12px;
            width: 100%;
            text-align: center;
            color:#808080 ;
            bottom: 0;
          p{
              padding-bottom: 5px;
          }
        }
    }
}
.enLogin{
    width: 100%;
    height: 100vh;
    background: url('~@/assets/images/qy_bg1.png') no-repeat 0 0;
    background-size: cover;
    overflow: hidden;
    position: relative;
    .enCenForm{
        width: 45vw;
        margin: 0 auto;
        height: 50vh;
        margin-top: 22vh;
        .qy_tit{
            height: 6vh;
            width: 100%;
        }
        .enCenForm-form{
            height: 44vh;
            background: #fff;
            margin-top: 3vh;
            border-radius: 5px;
            box-shadow: 0px 0px 7px rgba(0,0,0,.2);
            position: relative;
            .left_bg{
                width: 50%;
             
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .right-form{
                
                 .enform-tit{
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 500;
                color: #333333;
                line-height: 38px;
                padding-bottom: 10px;
            }
            .goReg{
                font-size: 14px;
                color: #767676;
                margin-bottom: 10px;
            }
                  .enform-ewm{
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    width: 38px;
                    cursor: pointer;
                }
                .enform-forget{
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #2C71C8;
                    line-height: 38px;
                    text-align: right;
                    padding-right: 40px;
                    cursor: pointer;
                }
                .enform-btn{
                   background: #2C71C8;
                   border-radius: 2px;
                   width: 85%;
                   text-align: center;
                   padding: 1.5vh 0;
                   color: #fff;
                   font-size: 16px;
                   margin-top: 3vh;
                   cursor: pointer;
                   outline: none;
                   border: none;
                }
            }
        }
    }
    .enform{
        display: none;
        width: 394px;
        height: 468px;
        background: url('~@/assets/images/enbg1.png') no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        margin-top: -234px;
        right: 18%;
      .enform-tit{
        padding: 30px 40px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #4B4B4B;
        line-height: 38px;
      }
      .enform-ewm{
        position: absolute;
        top: 40px;
        right: 40px;
        width: 38px;
        cursor: pointer;
      }
      .enform-ipt{
        padding: 30px 40px;
        margin-top: 30px;
        padding-bottom: 0px;
      }
      .enform-forget{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4A93F6;
        line-height: 38px;
        text-align: right;
        padding-right: 40px;
        cursor: pointer;
      }
      .enform-btn{
        text-align: center;
        margin-top: 30px;
        img{
            width: 176px;
            cursor: pointer;
        }
      }
    }
    
}
::v-deep{
    //  .el-input__inner{
    //     border: none;
    //     border-bottom: 1px solid #BCBCBC;
    //     border-radius: 0;
    // }
    // .el-input{
    //     margin-top: 40px;
    // }
    .el-input:first-child{
        margin-top: 0;
    }
    .el-input{
        margin-bottom: 10px;
       input{
         color: #285B9C !important;
       }
    }
}
@media (max-width: 640px){
    .newEnLogin{
        display: block !important;
        margin-top: -56px;
        .newEnLogin-left{
            width: 100%;
        }
        .newEnLogin-right{
            position: absolute;
            width: 90vw;
            top: 20%;
            left: 5vw;
            height: auto;
            padding-top: 50px;
            border-radius: 5px;
            .botinfo{display:none;}
        }
    }
    .enLogin{
        background-size: cover;
        background-position: 100%;
        margin-top: -56px;
        .enCenForm{
            display: none;
        }
        .enform{
            width: 320px;
            margin: 0 auto;
            position: absolute;
            top: 50%;
            margin-top: -200px;
            right: 50%;
            margin-right: -160px;
            height: 400px;
             display: block;
            .enform-ipt{
                margin-top: 0;
            }
        }
    }
}
</style>